function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// lib imports
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box, Image, Button, Heading, ResponsiveContext, Text } from 'grommet';
import { Menu } from 'grommet-icons/icons/';
import { FormPreviousLink, Logout } from 'grommet-icons';
import { withTheme } from 'styled-components';

// CORE imports
import * as SidebarDucks from 'granite-admin/accounts/ducks/sidebar';
import * as UserDucks from 'granite-admin/accounts/ducks/user';
import * as OrganisationDucks from 'granite-admin/organisations/ducks/organisations';
import * as ThemeConfigsDucks from 'granite-admin/common/ducks/themeConfigs';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import { checkSsoLogin } from 'granite-admin/utils/auth-singleton';
import EventEmitter from 'granite-admin/utils/event-emitter';
import Loader from 'granite-admin/core/components/Loader';
import Tooltip from 'granite-admin/core/components/Tooltip';
import VerticalMenu from 'granite-admin/core/components/VerticalMenu';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
// import { resetMyOrganisations } from 'granite-admin/utils/auth-singleton';
import MenuButton from 'granite-admin/core/components/MenuButton';
import UserDropMenu from 'granite-admin/core/components/UserDropMenu';
// import InviteUser from 'granite-admin/core/components/InviteUser';
import useUtility from 'granite-admin/utils/useUtility';
import DropBox from './components/DropBox';

// application imports
import logoImage from 'assets/logo.png';
import LightLogo from 'assets/logo_light.png';
import { loadMenuItemsAndPermissions } from 'granite-admin/accounts/controllers/sidebar';
import sideMenuRoutes from 'sideMenuRoutes';
import SidebarSkeletonLoader from './components/SidebarSkeletonLoader';
const hoverIndicatorOptions = {
  color: 'hover'
};
const COLLAPSE_ANIMATION_TIME = 500;
function fetchSidemenuItems(dispatch) {
  loadMenuItemsAndPermissions().then(response => {
    dispatch({
      type: 'accounts/sidebar/UPDATE_SIDEBAR',
      data: response
    });
    // dispatch({
    //   type: 'accounts/user/UPDATE_PERMISSIONS',
    //   data: response.permissions,
    // })
  }).catch(error => console.log('page error', error));
}
function listenEvents(eventEmitter) {
  const observable = eventEmitter.getObservable();
  const subscription = observable.subscribe(event => {
    // console.log(event);
    switch (event.type) {
      default:
        break;
    }
  });
  return subscription;
}
const Sidebar = ({
  dispatch,
  history,
  pathname,
  title,
  width,
  collapsible,
  headingProps,
  sidebarItems,
  userProfile,
  // userPermissions,
  collapsed,
  selectedOrganisation,
  themeConfigs,
  theme,
  sidebarPosition,
  showUserDropMenu,
  showUserProfile,
  showReferGranite,
  ...rest
}) => {
  let eventEmitter = useMemo(() => new EventEmitter(), []);
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  // const [hover, setHover] = useState(false);
  const [offsetHeight, setOffsetHeight] = useState(0);
  const ref = useRef(null);
  const config = useContext(ConfigContext);
  const {
    NotificationComponent
  } = config?.sidebarSettings;
  useEffect(() => {
    setOffsetHeight(ref.current.clientHeight);
  }, [setOffsetHeight]);
  const grandListner = React.useCallback(event => {
    switch (event.type) {
      case 'UPDATE_SIDEBAR':
        fetchSidemenuItems(dispatch);
        break;
      default:
        break;
    }
  }, [dispatch]);
  useUtility({
    grandListner
  });
  const setCollapsed = collapsed => {
    setTimeout(() => {
      grandEmitter.emit('SIDEBAR_COLLAPSED', collapsed);
    }, COLLAPSE_ANIMATION_TIME);
    dispatch({
      type: 'accounts/sidebar/UPDATE_COLLAPSED',
      data: collapsed
    });
  };
  useEffect(() => {
    const subscription = listenEvents(eventEmitter);
    if (sidebarItems.length === 0) fetchSidemenuItems(dispatch);
    return function cleanUp() {
      subscription.unsubscribe();
    };
  }, [eventEmitter, dispatch, sidebarItems]);
  useEffect(function init() {
    const subscription = listenEvents(eventEmitter);
    return function cleanUp() {
      subscription.unsubscribe();
    };
  }, [eventEmitter]);

  // const openInNewTab = path => {
  //   grandEmitter.emit('ADD_TAB', path);
  // };

  // const navigateBack = () => {
  //   dispatch({
  //     type: 'organisations/UPDATE_SELECTED_ORGANISATION',
  //     data: {},
  //   });
  //   dispatch({
  //     type: 'organisations/UPDATE_ORGANISATIONS',
  //     data: null,
  //   });
  //   dispatch({
  //     type: 'accounts/sidebar/RESET_SIDEBAR',
  //     data: [],
  //   });
  //   resetMyOrganisations();
  // };

  // const resetWorkspace = () => {
  //   dispatch({
  //     type: 'accounts/workspace/RESET_WORKSPACE',
  //   });
  // };
  const signOut = async () => {
    if (checkSsoLogin() === 'true') history.push('/sso-logout');else history.push('/logout');
  };
  return /*#__PURE__*/React.createElement(ResponsiveContext.Consumer, null, size => {
    const isCollapsed = collapsible && size === 'small' && collapsed === undefined || collapsed === true;
    return /*#__PURE__*/React.createElement(Box, _extends({
      width: isCollapsed ? '58px' : width,
      style: {
        minWidth: isCollapsed ? '58px' : width,
        position: 'relative',
        transition: `${COLLAPSE_ANIMATION_TIME / 1000.0}s`
      },
      elevation: "small",
      background: theme.global.colors['sidebar-background']
    }, rest), !selectedOrganisation?.pk && !isCollapsed && /*#__PURE__*/React.createElement(Box, {
      flex: false,
      align: "center",
      width: "100px",
      elevation: "xsmall",
      background: "#ffffff",
      style: {
        position: 'absolute',
        right: '0px',
        padding: '4px'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold",
      size: "small"
    }, "Product Console")), /*#__PURE__*/React.createElement(Box, {
      pad: {
        horizontal: 'medium',
        vertical: 'small'
      },
      direction: "row",
      align: "center",
      height: "75px"
    }, /*#__PURE__*/React.createElement(Button, {
      icon: /*#__PURE__*/React.createElement(Menu, {
        color: "sidebar-svg",
        size: "23px"
      })
      // isCollapsed && sidebarPosition === 'left' ? (
      //   <FormNext color="sidebar-svg" style={{ fontWeight: 800 }} />
      // ) : !isCollapsed && sidebarPosition === 'left' ? (
      //   <FormPrevious color="sidebar-svg" style={{ fontWeight: 800 }} />
      // ) : isCollapsed && sidebarPosition === 'right' ? (
      //   <FormPrevious color="sidebar-svg" style={{ fontWeight: 800 }} />
      // ) : (
      //   <FormNext color="sidebar-svg" style={{ fontWeight: 800 }} />
      // )
      ,

      onClick: () => setCollapsed(!collapsed),
      plain: true,
      focusIndicator: false,
      style: {
        zIndex: '0'
      }
    }), !isCollapsed && /*#__PURE__*/React.createElement(Box, _extends({
      align: "center",
      fill: true,
      flex: false,
      style: {
        marginLeft: '-28px'
      },
      justify: "around"
    }, headingProps), themeConfigs?.logo ? /*#__PURE__*/React.createElement(Image, {
      src: themeConfigs?.logo,
      alt: "Company Logo",
      width: "120px",
      height: "60px"
    }) : typeof title === 'string' ? /*#__PURE__*/React.createElement(Heading, {
      margin: "none",
      level: 3
    }, title) : null)), showUserProfile && userProfile?.profileImage && /*#__PURE__*/React.createElement(Box, {
      gap: "small",
      align: "center",
      justify: "center",
      margin: {
        vertical: 'large'
      }
    }, !isCollapsed && /*#__PURE__*/React.createElement(Image, {
      src: userProfile.profileImage,
      alt: "Profile Image",
      width: "120px"
    }), /*#__PURE__*/React.createElement(Tooltip, {
      align: sidebarPosition === 'right' ? 'left' : 'right',
      content: `${userProfile.firstName} ${userProfile.lastName}`
    }, /*#__PURE__*/React.createElement(Text, {
      wordBreak: "break-word"
    }, `${userProfile.firstName} ${userProfile.lastName}`))), /*#__PURE__*/React.createElement(Box, {
      flex: true
    }, sidebarItems.length === 0 || Boolean(userProfile) === false && config?.showSkeletonLoader ? /*#__PURE__*/React.createElement(SidebarSkeletonLoader, {
      isCollapsed: isCollapsed
    }) : sidebarItems.length === 0 || Boolean(userProfile) === false ? /*#__PURE__*/React.createElement(Box, {
      align: "center",
      justify: "center",
      fill: true
    }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
      border: {
        side: 'bottom',
        color: theme.global.colors['sidemenu-divider'],
        size: '1px'
      }
      // overflow={{ vertical: isCollapsed ? 'hidden' : 'auto', horizontal: 'hidden' }}
      ,
      overflow: {
        vertical: 'auto',
        horizontal: 'hidden'
      },
      flex: true
    }, /*#__PURE__*/React.createElement(VerticalMenu, {
      data: sidebarItems,
      pathname: pathname,
      isCollapsed: isCollapsed,
      hoverIndicatorOptions: hoverIndicatorOptions,
      offsetHeight: offsetHeight
      // sideMenuItem
      // openInNewTab={openInNewTab}
    })))), /*#__PURE__*/React.createElement(Box, {
      ref: ref
    }, userProfile.isSystemAdmin && selectedOrganisation?.pk && /*#__PURE__*/React.createElement(MenuButton, {
      isCollapsed: isCollapsed
      // label="Back to my board"
      ,
      label: " Back to platform admin",
      hoverIndicatorOptions: hoverIndicatorOptions,
      icon: /*#__PURE__*/React.createElement(FormPreviousLink, {
        size: "26px",
        color: theme.global.colors['sidebar-svg']
      }),
      onClick: () => {
        history.push('/back-to-board');
      }
    }), sideMenuRoutes.map((item, i) => {
      return /*#__PURE__*/React.createElement(DropBox, {
        key: 'sidebar' + i,
        isCollapsed: isCollapsed,
        hoverIndicatorOptions: hoverIndicatorOptions,
        data: item,
        sidebarPosition: sidebarPosition
      });
    }), /*#__PURE__*/React.createElement(NotificationComponent, {
      isCollapsed: isCollapsed,
      hoverIndicatorOptions: hoverIndicatorOptions,
      sidebarPosition: sidebarPosition
    }), showUserDropMenu ? /*#__PURE__*/React.createElement(UserDropMenu, {
      isCollapsed: isCollapsed,
      hoverIndicatorOptions: hoverIndicatorOptions,
      sidebarPosition: sidebarPosition,
      signOut: signOut
    }) : /*#__PURE__*/React.createElement(Box, {
      align: "center",
      pad: "medium"
    }, !isCollapsed ? /*#__PURE__*/React.createElement(Button, {
      icon: /*#__PURE__*/React.createElement(Logout, {
        size: "22px",
        color: "sidebar-icon"
      }),
      label: "Logout",
      onClick: signOut,
      plain: true
    }) : /*#__PURE__*/React.createElement(Tooltip, {
      align: sidebarPosition === 'right' ? 'left' : 'right',
      content: "Logout"
    }, /*#__PURE__*/React.createElement(Button, {
      icon: /*#__PURE__*/React.createElement(Logout, {
        size: "22px",
        color: "sidebar-icon"
      }),
      onClick: signOut,
      plain: true
    })))));
  });
};
Sidebar.defaultProps = {
  width: '256px',
  title: /*#__PURE__*/React.createElement(Image, {
    src: LightLogo || logoImage,
    alt: "Granite Logo",
    width: "120px"
  })
};
Sidebar.propTypes = {
  dispatch: PropTypes.func,
  pathname: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  width: PropTypes.string,
  collapsible: PropTypes.bool,
  headingProps: PropTypes.any,
  collapsed: PropTypes.any,
  sidebarPosition: PropTypes.string,
  showUserDropMenu: PropTypes.bool,
  showUserProfile: PropTypes.bool,
  showReferGranite: PropTypes.bool,
  themeConfigs: PropTypes.object,
  sidebarItems: PropTypes.array,
  theme: PropTypes.object,
  history: PropTypes.object,
  selectedOrganisation: PropTypes.object,
  userProfile: PropTypes.object
};
const mapStateToProps = state => ({
  sidebarItems: SidebarDucks.sidebarItems(state),
  collapsed: SidebarDucks.sidebarCollapsed(state),
  userProfile: UserDucks.profile(state),
  // userPermissions: UserDucks.permissions(state),
  selectedOrganisation: OrganisationDucks.selectedOrganisation(state),
  themeConfigs: ThemeConfigsDucks.themeConfigs(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Sidebar));